<template>
  <Intro />
  <FactSheetSelection />
</template>

<script setup lang="ts">
import Intro from "@/components/factSheet/factSheetIntro.vue";
import FactSheetSelection from "@/components/factSheet/FactSheetSelection.vue";

import { computed, onMounted, ref, toRefs } from "vue";

onMounted(async () => {
  //debugger;
  // window.scrollTo(0, 0);
});
</script>

